import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { LinkElement } from '../../types';

export const LINK_ELEMENTS: HTMLSerializeOptions['elements'] = {
    link: (node: LinkElement, children) => `<a href="${escapeHTML(node.href || '')}">${children}</a>`,
};
